var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { observable, action } from 'mobx';
import { api } from 'helpers/Api';
import { Invoice, CashDesk, Ticket, TicketCashDesk, PacketTicket, CollaboratorTicket } from './Model';
import CollaboratorPacketTicket from '../CollaboratorPacketTickets/Model';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.loading = false;
        this.invoices = [];
        this.tickets = [];
        this.generalTickets = [];
        this.virtualTickets = [];
        this.collaboratorTickets = [];
        this.operatorTickets = [];
        this.packetTickets = [];
        this.cashDesks = [];
        this.invoicesLoaded = false;
        this.ticketsLoaded = false;
        this.virtualTicketsLoaded = false;
        this.collaboratorTicketsLoaded = false;
        this.operatorTicketsLoaded = false;
        this.ticketGratisLoaded = false;
        this.ticketCanceledLoaded = false;
        this.cashDesksLoaded = false;
        this.ticketCashDesksLoaded = false;
        this.packetTicketsLoaded = false;
        this.total = 0;
        this.ticketCashDesk = [];
        this.ticketGratis = [];
        this.ticketCanceled = [];
        this.ticketCashDesksFromTo = [];
        this.ticketCashDesksFromToLoaded = false;
        this.error = false;
        this.eagerTicket = '[operationLine.[businessUnit], user, stretch, lines, payments, ticketRefunded.[lines, payments]]';
        this.eagerCollaboratorTicket = '[ticketRefunded]';
        this.eagerPacketTicket = '[lines, ticketRefunded.[lines, tickets], tickets.[lines, operationLine.[businessUnit]]]';
        this.rebook = function (data) {
            return api.post('tickets/rebook', data);
        };
        this.sendEmail = function (data) {
            var params = new URLSearchParams();
            params.append('numero', data.numero);
            params.append('clientName', data.clientName);
            params.append('language', data.language);
            params.append('emails', data.emails);
            params.append('action', data.action);
            console.log('params: ', params.toString());
            return api.get("contentEmail?".concat(params.toString()));
        };
        this.readGeneralSales = function (data) {
            _this.loading = true;
            return api.post("tickets/calendar/".concat(data.range), data)
                .then(_this.setGeneralSales)
                .catch(_this.setError);
        };
        this.setError = function (error) {
            console.log('post - tickets/calendar/${data.range} - catch - error: ', error);
            _this.error = true;
            _this.loading = false;
        };
        this.readVirtualTickets = function (data) {
            _this.virtualTicketsLoaded = false;
            return api.post("virtualtickets", data).then(_this.setVirtualTickets);
        };
        // los vendidos por colaboradores
        this.readOperatorTickets = function (data) {
            delete data.range;
            console.log('recuperando tickes vendidos por colaboradores');
            return api.post("collaboratorTickets/operator?eager=".concat(_this.eagerCollaboratorTicket), data).then(_this.setOperatorTickets);
        };
        this.setTicketCashDesksFromTo = function (ticketCashDesksFromTo) {
            // console.log('Report Store - setTicketCashDesk - ticketCashDesks: ', ticketCashDesks)
            _this.ticketCashDesksFromTo = ticketCashDesksFromTo.map(function (ticketCashDesk) { return new TicketCashDesk(ticketCashDesk); });
            _this.ticketCashDesksFromToLoaded = true;
            return _this.ticketCashDesksFromTo;
        };
        this.updateAdditionalNote = function (data) {
            return api.put('/tickets/additionalNote', data);
        };
        this.cancelTicket = function (ticket, user) {
            if (ticket.typeInstance === 'CollaboratorTicket' || ticket instanceof CollaboratorTicket) {
                delete ticket.typeInstance;
                return api.post("collaboratorTickets/refund", { ticketPayload: ticket, userid: user.id, username: user.username });
            }
            else if (ticket.typeInstance === 'Ticket' || ticket instanceof Ticket) {
                delete ticket.typeInstance;
                return api.post("tickets/refund", { ticketPayload: ticket, userid: user.id, username: user.username });
            }
            else {
                return new Promise(function (resolve, reject) {
                    reject({});
                });
            }
        };
        this.cancelPacketTicket = function (packetTicket, user) {
            return api.post('packetTickets/refund', { packetTicket_id: packetTicket.id, user_id: user.id });
        };
        this.setTickets = function (tickets) {
            _this.tickets = tickets.filter(function (ticket) { return !ticket.refund_id; }).map(function (ticket) { return new Ticket(ticket); });
            _this.ticketsLoaded = true;
        };
        this.setGeneralSales = function (result) {
            var _a, _b, _c, _d;
            var tickets = ((_a = result === null || result === void 0 ? void 0 : result.tickets) === null || _a === void 0 ? void 0 : _a.filter(function (ticket) { return !ticket.refund_id; }).map(function (ticket) { return new Ticket(ticket); })) || [];
            var packets = ((_b = result === null || result === void 0 ? void 0 : result.packetTickets) === null || _b === void 0 ? void 0 : _b.filter(function (pt) { return !pt.refund_id; }).map(function (pt) { return new PacketTicket(pt); })) || [];
            var ct = ((_c = result === null || result === void 0 ? void 0 : result.collaboratorTickets) === null || _c === void 0 ? void 0 : _c.filter(function (_ct) { return !_ct.refund_id; }).map(function (_ct) { return new CollaboratorTicket(_ct); })) || [];
            var cpt = ((_d = result === null || result === void 0 ? void 0 : result.collaboratorPacketTickets) === null || _d === void 0 ? void 0 : _d.filter(function (_cpt) { return !_cpt.refund_id; }).map(function (_cpt) { return new CollaboratorPacketTicket(_cpt); })) || [];
            _this.generalTickets = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], tickets, true), packets, true), ct, true), cpt, true).sort(function (a, b) { return a.datecheck.getTime() - b.datecheck.getTime(); });
            _this.ticketsLoaded = true;
            _this.loading = false;
        };
        this.setVirtualTickets = function (tickets) {
            _this.virtualTickets = tickets.filter(function (ticket) { return !ticket.refund_id; }).map(function (ticket) { return new Ticket(ticket); });
            _this.virtualTicketsLoaded = true;
        };
        this.setCollaboratorTickets = function (tickets) {
            _this.collaboratorTickets = tickets.filter(function (ticket) { return !ticket.refund_id; }).map(function (ticket) { return new CollaboratorTicket(ticket); });
            _this.collaboratorTicketsLoaded = true;
        };
        this.setOperatorTickets = function (tickets) {
            _this.operatorTickets = tickets.filter(function (ticket) { return !ticket.refund_id; }).map(function (ticket) { return new CollaboratorTicket(ticket); });
            _this.operatorTicketsLoaded = true;
        };
        this.setInvoices = function (invoices) {
            _this.invoices = invoices.map(function (invoice) { return new Invoice(invoice); });
            _this.invoicesLoaded = true;
        };
        this.setCashDesk = function (cashDesks) {
            _this.cashDesks = cashDesks.map(function (cashDesk) { return new CashDesk(cashDesk); });
            _this.cashDesksLoaded = true;
        };
        this.setTicketCashDesk = function (ticketCashDesks) {
            // console.log('Report Store - setTicketCashDesk - ticketCashDesks: ', ticketCashDesks)
            _this.ticketCashDesk = ticketCashDesks.map(function (ticketCashDesk) { return new TicketCashDesk(ticketCashDesk); });
            _this.ticketCashDesksLoaded = true;
        };
        this.setTicketGratis = function (tickets) {
            _this.ticketGratis = tickets.map(function (ticket) { return new Ticket(ticket); });
            _this.ticketGratisLoaded = true;
        };
        this.setPacketTickets = function (packetTickets) {
            // console.log('Reports/Store - setPacketTickets - packetTickets.length: ', packetTickets.length)
            _this.packetTickets = packetTickets.filter(function (item) { return !item.refund_id; }).map(function (packetTicket) { return new PacketTicket(packetTicket); });
            _this.packetTicketsLoaded = true;
            return _this.packetTickets;
        };
    }
    default_1.prototype.readInvoices = function () {
        return api.get('invoice').then(this.setInvoices);
    };
    default_1.prototype.readTickets = function () {
        return api.get("tickets?eager=".concat(this.eagerTicket)).then(this.setTickets);
    };
    // los vendidos como colaborador
    default_1.prototype.readCollaboratorTickets = function () {
        return api.get("collaboratorTickets/collaborator?eager=".concat(this.eagerCollaboratorTicket)).then(this.setCollaboratorTickets);
    };
    default_1.prototype.readPacketickets = function () {
        return api.get("packetTickets?eager=".concat(this.eagerPacketTicket)).then(this.setPacketTickets);
    };
    default_1.prototype.readCashDesk = function () {
        return api.get('cashDesk').then(this.setCashDesk);
    };
    default_1.prototype.readTicketCashDesks = function () {
        return api.get('ticketCashDesks?eager=[articleLines, stretchLines]').then(this.setTicketCashDesk);
    };
    default_1.prototype.readTicketCashDesksFromTo = function (from, to) {
        return api.post('ticketCashDesksFromTo?eager=[articleLines, stretchLines]', { from: from, to: to }).then(this.setTicketCashDesksFromTo);
    };
    default_1.prototype.readTicketGratis = function () {
        return api.get("ticketGratis?eager=".concat(this.eagerTicket)).then(this.setTicketGratis);
    };
    default_1.prototype.readTicketCanceled = function () {
        return api.get("ticketCanceled?eager=".concat(this.eagerTicket)).then(this.setTicketGratis);
    };
    default_1.prototype.readTicket = function (id) {
        return api.get("tickets?id=".concat(id, "&eager=").concat(this.eagerTicket));
    };
    default_1.prototype.readTicketCorrected = function (id) {
        return api.get("/rtickets/".concat(id, "?eager=[lines, user, operationLine.[businessUnit], payments]"))
            .then(function (result) {
            // console.log('result: ', result)
            return result;
        });
    };
    default_1.prototype.setTotal = function (total) {
        // console.log('Store - total', total)
        this.total = total;
    };
    __decorate([
        observable
    ], default_1.prototype, "loading", void 0);
    __decorate([
        observable
    ], default_1.prototype, "invoices", void 0);
    __decorate([
        observable
    ], default_1.prototype, "tickets", void 0);
    __decorate([
        observable
    ], default_1.prototype, "generalTickets", void 0);
    __decorate([
        observable
    ], default_1.prototype, "virtualTickets", void 0);
    __decorate([
        observable
    ], default_1.prototype, "collaboratorTickets", void 0);
    __decorate([
        observable
    ], default_1.prototype, "operatorTickets", void 0);
    __decorate([
        observable
    ], default_1.prototype, "packetTickets", void 0);
    __decorate([
        observable
    ], default_1.prototype, "cashDesks", void 0);
    __decorate([
        observable
    ], default_1.prototype, "invoicesLoaded", void 0);
    __decorate([
        observable
    ], default_1.prototype, "ticketsLoaded", void 0);
    __decorate([
        observable
    ], default_1.prototype, "virtualTicketsLoaded", void 0);
    __decorate([
        observable
    ], default_1.prototype, "collaboratorTicketsLoaded", void 0);
    __decorate([
        observable
    ], default_1.prototype, "operatorTicketsLoaded", void 0);
    __decorate([
        observable
    ], default_1.prototype, "ticketGratisLoaded", void 0);
    __decorate([
        observable
    ], default_1.prototype, "ticketCanceledLoaded", void 0);
    __decorate([
        observable
    ], default_1.prototype, "cashDesksLoaded", void 0);
    __decorate([
        observable
    ], default_1.prototype, "ticketCashDesksLoaded", void 0);
    __decorate([
        observable
    ], default_1.prototype, "packetTicketsLoaded", void 0);
    __decorate([
        observable
    ], default_1.prototype, "total", void 0);
    __decorate([
        observable
    ], default_1.prototype, "ticketCashDesk", void 0);
    __decorate([
        observable
    ], default_1.prototype, "ticketGratis", void 0);
    __decorate([
        observable
    ], default_1.prototype, "ticketCanceled", void 0);
    __decorate([
        observable
    ], default_1.prototype, "ticketCashDesksFromTo", void 0);
    __decorate([
        observable
    ], default_1.prototype, "ticketCashDesksFromToLoaded", void 0);
    __decorate([
        observable
    ], default_1.prototype, "error", void 0);
    __decorate([
        action
    ], default_1.prototype, "rebook", void 0);
    __decorate([
        action
    ], default_1.prototype, "readGeneralSales", void 0);
    __decorate([
        action
    ], default_1.prototype, "setError", void 0);
    __decorate([
        action
    ], default_1.prototype, "readVirtualTickets", void 0);
    __decorate([
        action
    ], default_1.prototype, "setTicketCashDesksFromTo", void 0);
    __decorate([
        action
    ], default_1.prototype, "setTotal", null);
    __decorate([
        action
    ], default_1.prototype, "setTickets", void 0);
    __decorate([
        action
    ], default_1.prototype, "setGeneralSales", void 0);
    __decorate([
        action
    ], default_1.prototype, "setVirtualTickets", void 0);
    __decorate([
        action
    ], default_1.prototype, "setCollaboratorTickets", void 0);
    __decorate([
        action
    ], default_1.prototype, "setOperatorTickets", void 0);
    __decorate([
        action
    ], default_1.prototype, "setInvoices", void 0);
    __decorate([
        action
    ], default_1.prototype, "setCashDesk", void 0);
    __decorate([
        action
    ], default_1.prototype, "setTicketCashDesk", void 0);
    __decorate([
        action
    ], default_1.prototype, "setTicketGratis", void 0);
    __decorate([
        action
    ], default_1.prototype, "setPacketTickets", void 0);
    return default_1;
}());
export default default_1;
export var typeList = {
    Report: 'report',
    Calendar: 'calendar'
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/Store.ts
// module id = 67
// module chunks = 0